import { isEditorEmpty } from "@av/components/organisms/editor/editor-content";

export function getLocalizedJobPostContent(
  values: Record<string, string> | undefined,
  locale: string
): string {
  return values?.[locale] ?? Object.values(values ?? {})[0] ?? "";
}

export function normalizeLocalizedText(
  localizedText: Record<string, string | null | undefined> | undefined,
  selectedLocales: string[],
  isRichText = false
): Record<string, string> | undefined {
  if (!localizedText) {
    return localizedText;
  }

  const normalized = Object.fromEntries(
    Object.entries(localizedText).flatMap(([locale, value]) => {
      if (value == null || !selectedLocales.includes(locale)) {
        return [];
      }

      const trimmedValue = value.trim();
      const normalizedValue =
        isRichText && isEditorEmpty(trimmedValue, "richText") ? "" : trimmedValue;

      return [[locale, normalizedValue]];
    })
  );

  return Object.keys(normalized).length ? normalized : undefined;
}
